import { render } from "./EffectiveScenario.vue?vue&type=template&id=0b354d88"
import script from "./EffectiveScenario.vue?vue&type=script&lang=js"
export * from "./EffectiveScenario.vue?vue&type=script&lang=js"

import "./EffectiveScenario.vue?vue&type=style&index=0&id=0b354d88&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QTooltip,QMarkupTable});
